/*
 * No.9 Caffè — Header - No.9
 * Mobile drawer open/close. Delegated + idempotent so it survives Shopify
 * section re-renders in the theme editor. Locks body scroll while open,
 * closes on overlay click, Escape, or navigating a link.
 */
(function () {
  if (window.__no9Header) return;
  window.__no9Header = true;

  function header(el) {
    return el.closest('.hd-no9');
  }

  function openDrawer(hd) {
    hd.classList.add('is-drawer-open');
    const btn = hd.querySelector('[data-drawer-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer(hd) {
    hd.classList.remove('is-drawer-open');
    const btn = hd.querySelector('[data-drawer-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('[data-drawer-toggle]');
    if (toggle) {
      e.preventDefault();
      const hd = header(toggle);
      if (!hd) return;
      hd.classList.contains('is-drawer-open') ? closeDrawer(hd) : openDrawer(hd);
      return;
    }

    if (e.target.closest('[data-drawer-close]')) {
      const hd = header(e.target);
      if (hd) closeDrawer(hd);
      return;
    }

    // Navigating a drawer link closes the drawer.
    const drawerLink = e.target.closest('.hd-no9__drawer a');
    if (drawerLink) {
      const hd = header(drawerLink);
      if (hd) closeDrawer(hd);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.hd-no9.is-drawer-open').forEach(closeDrawer);
  });

  // Close any open drawer when a section re-renders in the editor.
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.hd-no9.is-drawer-open').forEach(closeDrawer);
  });

  /* ---- Sticky header ---------------------------------------------------
     Modes (set per section, the announcement bar follows automatically):
       always     - the whole group stays pinned at the top
       scroll_up  - the group hides going down, slides back on the way up
       none       - normal flow

     TWO THINGS THAT MADE EARLIER VERSIONS FAIL, both fixed here:

     1. There is NO wrapper element around a Shopify section group. The
        class `shopify-section-group-header-group` is applied to EACH
        section (Dawn's own selector `.section-header.shopify-section-group
        -header-group` puts both classes on one element). So the group has
        to be treated as a set of SIBLING sections and pinned as a stack
        with cumulative top offsets — otherwise only the header moves and
        the announcement bar is left behind.

     2. The header section emits `#shopify-section-<id> { position:
        relative }` inline, an ID selector that outranks any stylesheet
        rule. Everything positional here is therefore written as an INLINE
        STYLE, which beats ID selectors outright. */
  (function stickyHeader() {
    var SHOW_AFTER = 30; // px of accumulated UPWARD travel before revealing
    var HIDE_AFTER = 60; // px of accumulated DOWNWARD travel before hiding
    var GROUP = 'shopify-section-group-header-group';

    function scrollY() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    // Every sibling section belonging to the same header group, in order.
    // `withGroup` false = pin the header alone and let the announcement bar
    // scroll away normally.
    function groupOf(section, withGroup) {
      if (!withGroup) return [section];
      if (!section.classList.contains(GROUP) || !section.parentNode) return [section];
      var out = [];
      var kids = section.parentNode.children;
      for (var i = 0; i < kids.length; i++) {
        if (kids[i].classList && kids[i].classList.contains(GROUP)) out.push(kids[i]);
      }
      return out.length ? out : [section];
    }

    function setup(inner) {
      var mode = inner.getAttribute('data-sticky-mode') || 'scroll_up';
      if (mode === 'none') return;

      var section = inner.closest('.shopify-section') || inner;
      var withGroup = inner.getAttribute('data-sticky-with-announcement') !== 'false';
      var parts = groupOf(section, withGroup);
      var first = parts[0];
      var last = parts[parts.length - 1];

      if (first.dataset.no9Sticky === 'on') return;
      first.dataset.no9Sticky = 'on';
      parts.forEach(function (el) {
        el.classList.add('no9-sticky-host');
      });

      // Heights must all be read BEFORE any element leaves the flow,
      // otherwise each change invalidates the next measurement.
      function heights() {
        return parts.map(function (el) {
          return el.offsetHeight;
        });
      }

      /* ---------- always ---------- */
      if (mode === 'always') {
        var stick = function () {
          var hs = heights();
          var off = 0;
          parts.forEach(function (el, i) {
            el.style.position = 'sticky';
            el.style.top = off + 'px';
            el.style.zIndex = String(30 + (parts.length - i));
            off += hs[i];
          });
        };
        stick();
        window.addEventListener('resize', stick, { passive: true });
        return;
      }

      /* ---------- scroll_up ---------- */
      var spacer = document.createElement('div');
      spacer.className = 'hd-no9__spacer';
      spacer.setAttribute('aria-hidden', 'true');
      last.parentNode.insertBefore(spacer, last.nextSibling);

      var pinned = false;
      var hidden = false;
      var lastY = scrollY();
      var upAccum = 0;
      var downAccum = 0;
      var ticking = false;
      var anchor = 0;
      var totalH = 0;

      function measure() {
        if (pinned) return; // offsets are viewport-relative once fixed
        var rect = first.getBoundingClientRect();
        anchor = Math.max(0, Math.round(rect.top + scrollY()));
        totalH = heights().reduce(function (a, b) {
          return a + b;
        }, 0);
      }

      function silently(fn) {
        parts.forEach(function (el) {
          el.classList.add('no9-no-anim');
        });
        fn();
        void first.offsetHeight; // flush so the change is committed
        parts.forEach(function (el) {
          el.classList.remove('no9-no-anim');
        });
      }

      function applyShift() {
        var y = hidden ? 'translateY(-' + totalH + 'px)' : '';
        parts.forEach(function (el) {
          el.style.transform = y;
        });
      }

      function setPinned(on) {
        if (on === pinned) return;
        if (on) {
          measure();
          var hs = heights();
          silently(function () {
            var off = 0;
            parts.forEach(function (el, i) {
              el.style.position = 'fixed';
              el.style.top = off + 'px';
              el.style.left = '0';
              el.style.right = '0';
              el.style.zIndex = String(30 + (parts.length - i));
              el.style.willChange = 'transform'; // promote only while pinned
              off += hs[i];
            });
            spacer.style.height = totalH + 'px';
            hidden = true; // pin out of sight; the reveal must be earned
            applyShift();
          });
          pinned = true;
        } else {
          silently(function () {
            parts.forEach(function (el) {
              el.style.position = '';
              el.style.top = '';
              el.style.left = '';
              el.style.right = '';
              el.style.zIndex = '';
              el.style.transform = '';
              el.style.willChange = '';
            });
            spacer.style.height = '0px';
          });
          pinned = false;
          hidden = false;
        }
      }

      function reveal(on) {
        if (on === !hidden) return;
        hidden = !on;
        applyShift();
      }

      function update() {
        ticking = false;
        var y = scrollY();
        if (y < 0) y = 0; // rubber-band overscroll

        // Accumulated travel, not per-frame delta: a rAF-throttled handler
        // only sees 1-3px per frame on a slow scroll.
        if (y < lastY) {
          upAccum += lastY - y;
          downAccum = 0;
        } else {
          downAccum += y - lastY;
          upAccum = 0;
        }
        lastY = y;

        if (y <= anchor) {
          setPinned(false); // pinned and flow positions coincide — no jump
        } else if (!pinned && y >= anchor + totalH) {
          setPinned(true); // fully out of sight, so pinning is invisible
        }

        if (!pinned) return;

        var live = section.querySelector('.hd-no9') || inner;
        if (live.classList.contains('is-drawer-open')) {
          reveal(true);
          return;
        }
        if (upAccum > SHOW_AFTER) reveal(true);
        else if (downAccum > HIDE_AFTER) reveal(false);
      }

      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(update);
        },
        { passive: true }
      );

      // Re-measure WITHOUT leaving the pinned state. Unpinning to measure
      // drops the sections back into the flow for a frame, which yanks the
      // whole page — the "choppy" feel on mobile. While pinned the spacer
      // occupies the block's slot, so it can be read instead, and heights
      // are still valid on fixed elements.
      function remeasure() {
        if (!pinned) {
          measure();
          return;
        }
        var hs = heights();
        totalH = hs.reduce(function (a, b) {
          return a + b;
        }, 0);
        anchor = Math.max(0, Math.round(spacer.getBoundingClientRect().top + scrollY()));

        silently(function () {
          var off = 0;
          parts.forEach(function (el, i) {
            el.style.top = off + 'px';
            off += hs[i];
          });
          spacer.style.height = totalH + 'px';
          applyShift(); // keeps a hidden bar exactly off-screen
        });
      }

      // Mobile browsers fire `resize` every time the URL bar shows/hides
      // while scrolling. Reacting to those would re-measure constantly, so
      // only a real WIDTH change counts, and it is debounced.
      var lastW = window.innerWidth;
      var resizeTimer = null;
      window.addEventListener(
        'resize',
        function () {
          if (window.innerWidth === lastW) return; // height-only: URL bar
          lastW = window.innerWidth;
          if (resizeTimer) window.clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(function () {
            remeasure();
            update();
          }, 150);
        },
        { passive: true }
      );

      window.addEventListener('orientationchange', function () {
        window.setTimeout(function () {
          lastW = window.innerWidth;
          remeasure();
          update();
        }, 250);
      });

      measure();
      update();
    }

    function init() {
      document.querySelectorAll('.hd-no9--sticky').forEach(setup);
    }

    init();
    document.addEventListener('shopify:section:load', init);
  })();
})();

/*
 * No.9 Caffè — in-page anchor links.
 *
 * Nav items like FAQ are stored in Shopify as absolute URLs
 * (https://no9caffe.com/#faq). Two problems follow: from a theme preview they
 * navigate off to the live site, and they always land on the HOME page's
 * section even when the current page has one of its own.
 *
 * So: if the link carries a hash and an element with that id exists on this
 * page, scroll to it instead of navigating. Links whose target isn't here fall
 * through untouched and still work as ordinary cross-page links.
 */
(function () {
  if (window.__no9AnchorLinks) return;
  window.__no9AnchorLinks = true;

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var link = e.target.closest && e.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

    // Parsed against the document so relative, root-relative and absolute
    // hrefs are all handled the same way.
    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (err) {
      return;
    }
    if (!url.hash || url.hash === '#') return;

    var id = decodeURIComponent(url.hash.slice(1));
    var target = document.getElementById(id);
    if (!target) return; // not on this page — let the browser navigate

    e.preventDefault();

    // Close the mobile drawer first, or the scroll happens behind an overlay.
    // Clicking the toggle reuses the existing open/close handler rather than
    // reaching into its internals; guarded on the open state so it can't open
    // a closed drawer.
    var openHeader = document.querySelector('.hd-no9.is-drawer-open');
    if (openHeader) {
      var toggle = openHeader.querySelector('[data-drawer-toggle]');
      if (toggle) toggle.click();
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // Keep the hash in the address bar without a second jump.
    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', url.hash);
    }
  });

  /*
   * Arriving with a hash already in the URL — a full navigation from another
   * page, a shared link, a reload. The browser jumps as soon as it sees the
   * anchor, but the hero image and web fonts land afterwards and reflow the
   * page, which drops you back near the top. Re-applying it once everything
   * has loaded lands on the section for real.
   */
  function scrollToCurrentHash() {
    if (!window.location.hash || window.location.hash === '#') return;
    var id;
    try {
      id = decodeURIComponent(window.location.hash.slice(1));
    } catch (err) {
      return;
    }
    var target = document.getElementById(id);
    if (!target) return;
    // Instant, not smooth — a page arriving at its anchor should already be
    // there, not animate once the images pop in.
    requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: 'auto', block: 'start' });
    });
  }

  if (document.readyState === 'complete') {
    scrollToCurrentHash();
  } else {
    window.addEventListener('load', scrollToCurrentHash);
  }
})();
